module.exports = __webpack_public_path__ + "img/attach_file.81c086bd.svg";